import SearchField from "../../components/textfield/searchField";
import { Table, TableColumn } from "../../components/table";
import { useHistory } from "react-router-dom";
import HeaderBar from "../../components/header/headerBar";
import LoadingCard from "../../components/LoadingCard";
import Select from "../../components/select/select";
import { useState, useEffect } from "react";
import "../../assets/styles/admin/usedcourse.scss";
import axios from "axios";

const UsedCourse = () => {
  const [listCourses, setListCourses] = useState<any>([]);
  const [search, setSearch] = useState<string>("");
  const [dataLoaded, setDataLoaded] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const history = useHistory();
  const columns = [
    {
      title: "",
      align: "left",
      width: "46px",
    },
    {
      title: "รหัสการขาย<br/>SO",
      align: "center",
      width: "150",
    },
    {
      title: "รหัสลูกค้า<br/>CN",
      align: "center",
      width: "138px",
    },
    {
      title: "ชื่อ-นามสกุล,เบอร์โทร<br/>Name-Surname, Mobile",
      align: "center",
      width: "300px",
    },
    {
      title: "เลขที่ใบยา<br/>Ref.VN",
      align: "center",
      width: "120px",
    },
    {
      title: "สาขาที่ซื้อ<br/>Purchase Branch",
      align: "center",
      width: "181px",
    },
    {
      title: "วันที่ซื้อ<br/>Purchase Date",
      align: "center",
      width: "150px",
    },
    {
      title: "ผู้ดูแล<br/>Consultant",
      align: "center",
      width: "141px",
    },
    {
      title: "เลขที่บัตรคอร์ส<br/>Course Card ID",
      align: "center",
      width: "203px",
    },
    {
      title: "ราคาขาย<br/>Sale Price",
      align: "center",
      width: "136px",
    },
    {
      title: "สถานะ<br/>Status",
      align: "center",
      width: "100px",
    },
  ];

  const optbranch = [{ value: "", name: "All" }];
  const optstatus = [{ value: "", name: "All" }];

  const getData = async () => {
    setLoading(true);
    let qsearch = search;
    if (qsearch.startsWith("+")) {
      qsearch = search.substring(1);
    }

    const { data } = await axios.get(`/use-courses?name=${qsearch}`);

    if (!data) return;

    // console.log("data =>", data.data);

    setListCourses(data.data);

    setDataLoaded(true);
    setLoading(false);
  };

  useEffect(() => {
    if (dataLoaded) {
      getData();
    }
  }, [search]);

  useEffect(() => {
    getData();
  }, []);

  return (
    <div>
      <HeaderBar title="USED COURSE" />
      <div style={{ margin: "10px 40px" }}>
        <SearchField
          placeholder="Search for customer (CN, Name, Mobile No.)"
          color="#FFF"
          onKeyUp={(e: any) => {
            const value = e.target.value;
            // console.log('value =>', value);
            if (!value) setSearch("");
            setSearch(value.trim());
          }}
        />
        <div className="d-flex justify-content" style={{ margin: "0px 20px" }}>
          <div className="catesort">
            <Select title="CATEGORY :" option={optbranch} />
          </div>
          <div className="catesort">
            <Select title="STATUS :" option={optstatus} />
          </div>
        </div>

        <div style={{ marginTop: "20px" }}>
          {!dataLoaded || loading ? (
            <LoadingCard />
          ) : (
            <Table header={columns} fixed={true} headerPadding="7px 10px">
              {!dataLoaded || loading ? (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    Loading...
                  </td>
                </tr>
              ) : listCourses.length ? (
                listCourses.map((item: any, index: number) => (
                  <tr
                    key={index}
                    onClick={() => {
                      history.push(`/usedcourse/${item._id}`);

                      // if (item.status !== "deposit") {
                      //   if (!item.code.includes("PRO")) {
                      //     history.push(`/usedcourse/${item._id}`);
                      //   } else {
                      //     history.push(`/usedcourse/Coursedetail/${item._id}`);
                      //   }
                      // }
                    }}
                    style={{ cursor: "pointer" }}
                  >
                    <TableColumn align="center">{index + 1}</TableColumn>
                    <TableColumn>{item.code}</TableColumn>
                    <TableColumn>{item.memberCode}</TableColumn>
                    <TableColumn>
                      {item.memberName}
                      <br />
                      {item.phone}
                    </TableColumn>
                    <TableColumn align="center">{item.vn || "-"}</TableColumn>
                    <TableColumn align="center">
                      {item.branchName || "-"}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatCreatedAt}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatConsults || "-"}
                    </TableColumn>
                    <TableColumn align="center">
                      {item.formatCourseIds}
                    </TableColumn>
                    <TableColumn align="right">{item.formatPrice}</TableColumn>
                    <TableColumn
                      align="center"
                      key={index}
                      backgroundColor={
                        item.statusPayment === "paid_full"
                          ? "#C7F0D8"
                          : "#FEEFC7"
                      }
                      style={{
                        fontWeight: "500",
                        color:
                          item.statusPayment === "paid_full"
                            ? "#4D7E7F"
                            : "#F3A086",
                      }}
                    >
                      {item.formatStatus}
                    </TableColumn>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={8} style={{ textAlign: "center" }}>
                    No data
                  </td>
                </tr>
              )}
            </Table>
          )}
        </div>
      </div>
    </div>
  );
};
export default UsedCourse;
